"use client";

import React from "react";
import { Sparkles, Layout, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * PagemakerForAllIndustries — Section 2: Intro mit USP
 * Drop-in für: src/pages/PagemakerForAllIndustries/sections/GetInTouch.tsx
 */

const usps = [{
  icon: Sparkles,
  title: "KI versteht Ihre Branche",
  description: "Beschreiben Sie Ihr Geschäft — die KI weiss, welche Sektionen, Texte und Bilder dazu passen."
}, {
  icon: Layout,
  title: "Branchenspezifische Layouts",
  description: "Speisekarte beim Restaurant, Anfrage-Formular beim Handwerker, Termin-Buchung beim Coach — alles automatisch."
}, {
  icon: Globe,
  title: "Lokale SEO inklusive",
  description: 'Automatische Optimierung für Branchen-spezifische Suchanfragen wie „Coiffeur Bern" oder „Maler Zürich".'
}];
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Eine Engine, die jede Branche versteht
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Sie müssen kein Webdesigner sein, um eine perfekte Website für Ihre
            Branche zu bekommen. Beschreiben Sie Ihr Geschäft — die KI macht
            den Rest.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {usps.map((u, i) => <div key={i} className="bg-background border border-border rounded-xl p-7 text-center">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <u.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2 tracking-tight">
                {u.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {u.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}